import { useEffect, useState } from "react";
import { api } from "../api/api";

const useAdvogados = () => {
  const [advogados, setAdvogados] = useState([]);
  const [parceiros, setParceiros] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const buscarDados = async () => {
      try {
        const [resAdvogados, resParceiros] = await Promise.all([
          api.get("/advogados"),
          api.get("/advogados/parceiros")
        ]);

        setAdvogados(resAdvogados.data);
        setParceiros(resParceiros.data);

      } catch (err) {
        console.log("Erro ao buscar advogados");
      } finally {
        setLoading(false);
      }
    };

    buscarDados();
  }, []);

  return { advogados, parceiros, loading };
};

export default useAdvogados;